// Library Class
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, HostListener, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSelectionList } from '@angular/material/list';
import { NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatCalendarCellCssClasses, MatCalendar } from '@angular/material/datepicker';
// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { CppReturnAddProductSliderModelService } from '../../../common/components/cpp-return-add-product/cpp-return-product-slider-model.service';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { MatDatepicker } from '@angular/material/datepicker';
import { CommonService } from '../../../services/common/common.service';
import { UserSecurityService } from '../../../services/common/user-security.service';

@Component({
  selector: 'app-cpp-returns-create-edit',
  templateUrl: './cpp-returns-create-edit.component.html',
  styleUrls: ['./cpp-returns-create-edit.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CppReturnsCreateEditComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('freightInstructionCtrl') freightInstructionCtrl: MatSelectionList;
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;
  @ViewChild('picker') datepicker: MatDatepicker<any>;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;

  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  public deliveryAccount: number;
  shipToAccountName: number;
  shipToAccountItems: any[];
  soldToFacility: any[];
  soldToAccount: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  isinoculentdate: boolean = false;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue = '';
  partialSearchValue = '';
  lotNumberList: any = [];
  invoicedProductList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'itemNumber', 'eligibleUnits', 'dumpedUnits', 'uom', 'packageSize', 'notes'];
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  showTabs = false;
  showScaleTabs = false;
  tabNode: string;
  editToolKit = false;
  isParent = false;
  lineStatus: any = '';
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  statusList: any = [
    // { 'id': 'APPROVED', 'value': 'APPROVED' },
    { 'id': 'ERROR', 'value': 'ERROR' },
    // { 'id': 'PENDING', 'value': 'PENDING' },
    // { 'id': 'REJECTED', 'value': 'REJECTED' }
  ];
  // Search Type set Up fro grid
  searchTypeList: any = [
    { name: 'Product Name', value: 'productName' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Vendor Name', value: 'vendorName' },
    { name: 'Product Line', value: 'productLine' },
    { name: 'Item Number', value: 'itemNumber' },
  ];
  shipToDataLoading = true;
  disablecheckbox: any;
  disableScaleCheckbox: any;
  selectedCount = 0;
  checkBoxCount = 0;
  selectedAccountName: any = '';
  isSearchClicked: any;
  index: any;
  enable: any;
  returnRequestNumber = 0;
  returnRequestCppId = 0;
  isEditMode = false;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  readOnlyAccess = false;
  userMenuAccessList: any;
  date = new Date();
  minDate = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  dsmInfo: string;
  dsmId = 0;
  filterValueList: any = [];
  productFilters: any;
  productList: any[];
  productSearchFilter: string;
  filterInvoicedProductitems: any[] = [];
  isAllProductChecked = false;
  userIdRole: string;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;
  isExpanded = true;

  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  deliverToAnotherLocation = false;

  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  packageSizeMasterList: any = [];
  onBehalfUser: any;
  selectedUserName: string;
  productLineSub: Subscription;
  selectedWeekdays = [];
  defaultDelDate = new Date();
  desiredDelDate = new Date();
  selectedShipToWeekdays = [];
  defaultShipToDelDate = new Date();
  desiredShipToPickupDate = new Date();
  isAcctSDM: boolean = false;
  isShowNonSubEmail: boolean = true;
  isReturnTypeForInnoculant: boolean = false;
  warningMessage: string = "";
  ipNotConfiguredErrorMessage: string = "";

  public freightInstruction: any = [];
  // set default pickup date as T+2 for new return.
  public desiredPickupDate: any = this.SetDesiredPickupDate();
  public contactName: string;
  public contactNumber: string;
  public customerPONumber: string;
  public shippingInstructions: string;
  public selectedFreightInstructionOptions: any;
  public palletCount: string;
  public deliveryAccountList: Array<any> = [];
  private subscription = new Subscription();

  public rdProduct: boolean = null;
  chatAccess = true;

  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public cppReturnsService: CppReturnsService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private datePipe: DatePipe,
    public matDialog: MatDialog,
    private cppReturnAddProductSliderModelService: CppReturnAddProductSliderModelService,
    private localStorageService: LocalStorageService,
    private userSecurityService: UserSecurityService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();

    this.subscription.add(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.SetDesiredPickupDate();

    this.requestStatus = this.cppReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL

          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestCppId']) {
              this.returnRequestCppId = +x['returnRequestCppId'];
              this.isEditMode = true;
              this.isExpanded = false;
              this.editButtonStatus();
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
      this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant
    }
    this.resetProductFilter();
    this.hasChangeAdded = false;
    this.loadMasterData();
    this.productAllDataSource = new MatTableDataSource([]);
    this.disablecheckbox = true;
    this.disableScaleCheckbox = true;
    this.getAccountList();
    this.getFreightList();
    this.cppReturnsService.setEditModeStatus(false);
    this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant

    if (this.isReturnTypeForInnoculant) {
      this.cppReturnsService.getInoculantRestriction().subscribe((result: any) => {
        this.isinoculentdate = result;
      });
      this.rdProduct = true
      this.cppReturnsService.getCPPReturnsInoculantWarningMessage().subscribe((result: any) => {
        this.warningMessage = result.message;
      });
      this.cppReturnsService.getCPPReturnsInoculantErrorMessage().subscribe((result: any) => {
        this.ipNotConfiguredErrorMessage = result.message;
      });
    }
    this.enableFiltersAndButtonAsPermission();
    this.subscription.add(this.cppReturnAddProductSliderModelService.cppReturnModelData.subscribe(selectedProductList => {
      if (selectedProductList.length > 0) {
        this.disablecheckbox = false;
        this.disableScaleCheckbox = false;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        this.errorMsgs = [];
        this.isEditMode = this.cppReturnsService.getEditModeStatus();
        this.originalProductItemsDataSource = this.productAllDataSource.data;
        const orderList = [];
        let rowId = 0;
        this.productAllDataSource.data.forEach(x => {
          orderList.push(x);
          if (x.rowId > rowId) { rowId = x.rowId; }
        });
        let productAdded = true;
        selectedProductList.forEach(item => {
          let duplicateData = orderList.find(y => y.itemId == item.itemId);
          item.lineErrors = { 'itemId': item.itemId, 'errors': [] };
          item.lineError = false;
          if (duplicateData && !duplicateData.isManualLine && duplicateData.isParent !== item.isParent) {
            const index = orderList.indexOf(duplicateData);
            if (index !== -1) {
              orderList.splice(index, 1);
              duplicateData = undefined;
            }
          }

          if (duplicateData == undefined) {
            item.returnRequestItemCppId = 0;
            item.returnQuantity = 0;
            if (this.isReturnTypeForInnoculant) {
              item.eligibleUnit = item.isManualLine ? 0 : item.eligibleUnit ? item.eligibleUnit : (item.invoiceUnits) > 0 ? (item.invoiceUnits) : 0;
              item.isReturnToDraft = false;
              item.creditIssued = item.creditIssued ? item.creditIssued : 0;
            }
            else {
              item.eligibleUnit = item.isManualLine ? 0 : item.eligibleUnit ? item.eligibleUnit : (item.invoiceUnits - item.totalReturnUnits) > 0 ? (item.invoiceUnits - item.totalReturnUnits) : 0;
            }
            orderList.push(item);
            if (productAdded) {
              this.toastrService.info('Product Added');
              productAdded = false;
            }
          } else {// Addition use case implemented asked in bug 74741
            if (duplicateData.isManualLine && !item.isManualLine) {
              duplicateData.isManualLine = false;
              if (this.isReturnTypeForInnoculant) {
                duplicateData.eligibleUnit = (item.invoiceUnits) > 0 ? (item.invoiceUnits) : 0;
                item.isReturnToDraft = false;
                item.creditIssued = item.creditIssued ? item.creditIssued : 0;
              }
              else {
                duplicateData.eligibleUnit = (item.invoiceUnits) > 0 ? (item.invoiceUnits) : 0;
              }
              duplicateData.isParent = item.isParent;
              duplicateData.invoiceType = item.invoiceType;
              duplicateData.invoiceUnits = item.invoiceUnits;
              duplicateData.invoicedProductId = item.invoicedProductId;
              duplicateData.isEligible = true;
              duplicateData.isManualLine = false;
              duplicateData.isParent = item.isParent;
              duplicateData.isSelected = item.isSelected;
              duplicateData.lineStatus = '';
              duplicateData.originalInvoiceDate = item.originalInvoiceDate;
              duplicateData.originalInvoiceEndDate = duplicateData.originalInvoiceEndDate;
              duplicateData.originalInvoiceStartDate = item.originalInvoiceStartDate;
              duplicateData.unitPrice = item.unitPrice;
              this.toastrService.info('Product Added');
              productAdded = false;
            }
            else {
              this.toastrService.warning('Product is already on the request');
            }
          }
        });
        this.productAllDataSource.data = orderList;
        this.originalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
        this.enablePlaceOrderAndSaveOrderDraft();

        this.selectedCount = orderList.length;
        this.isAllProductChecked = false;
        this.bindDataSource(orderList, true);
      }
    }));
    this.validateDateFilter();
    this.errorMsgs = new Array();
    this.subscription.add(this.userSecurityService.getChatAccess().subscribe(results => {
      this.chatAccess = results.isChatActive;
    }));

    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  // Toggle Pickup Section
  togglePickup() {
    this.isExpanded = !this.isExpanded;
  }

  public resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'invoicedProductList': [],
      'lotNumberList': [],
      'productName': '',
      'packageSize': '',
      'vendorName': '',
      'productLine': '',
      'status': [],
    };
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
      this.productAllDataSource.filterPredicate = (data: any, filter: any) => {
        if ((filter.invoicedProductList.length == 0 || (filter.invoicedProductList.indexOf(data.itemNumber.trim()) > -1))
          && (filter.lotNumberList.length == 0 || (filter.lotNumberList.indexOf(data.lotNumber.trim()) > -1))
          // && (filter.packageSize.length == 0 || (filter.packageSize.indexOf(data.packageSizeDesc) > -1))
          && (filter.packageSize == null || (data.packageSize.trim().toLowerCase().indexOf(filter.packageSize.trim().toLowerCase()) > -1))
          && (filter.productName == null || (data.itemDescription.trim().toLowerCase().indexOf(filter.productName.trim().toLowerCase()) > -1))
          && (filter.vendorName == null || (data.itemVendorName.trim().toLowerCase().indexOf(filter.vendorName.trim().toLowerCase()) > -1))
          && (filter.productLine == null || (data.productLine.trim().toLowerCase().indexOf(filter.productLine.trim().toLowerCase()) > -1))
          && (filter.status.length == 0 || (filter.status.indexOf(data.lineStatus) > -1))) {
          this.filterInvoicedProductitems.push(data);
          this.filteredDataCount = this.filteredDataCount + 1;
          return true;
        }
        else {
          return false;
        }
      };
      this.applyFilterData(this.productFilters);
    }
  }

  public selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productName = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  // Filter products by package size
  public selectPackageSize($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.packageSize = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.packageSize = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.packageSize = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public selectVendorName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.vendorName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.vendorName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.vendorName = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public selectProductLine($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 1) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productLine = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productLine = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 1) {
          this.productFilters.productLine = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.invoicedProductList && this.productFilters.invoicedProductList.length > 0) {
          var strMB = '';
          this.productFilters.invoicedProductList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.lotNumberList && this.productFilters.lotNumberList.length > 0) {
          var strMB = '';
          this.productFilters.lotNumberList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Lot Number : ' + strMB.substr(0, strMB.length - 2));
        }

        // Set Product Name
        if (this.productFilters.productName && this.productFilters.productName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.productName);
        }

        // Set Package Size
        if (this.productFilters.packageSize && this.productFilters.packageSize != '') {
          this.filterValueList.push('Package Size : ' + this.productFilters.packageSize);
        }

        // Set Vendor Size
        if (this.productFilters.vendorName && this.productFilters.vendorName != '') {
          this.filterValueList.push('Vendor Name : ' + this.productFilters.vendorName);
        }

        // Set Product Line
        if (this.productFilters.productLine && this.productFilters.productLine != '') {
          this.filterValueList.push('Product Line : ' + this.productFilters.productLine);
        }

        // Set Package Size
        // if (this.productFilters.packageSize && this.productFilters.packageSize.length > 0) {
        //  var strINO = "";
        //  this.productFilters.packageSize.forEach(x => {
        //    strINO = strINO + x + ", ";
        //  });
        //  this.filterValueList.push("Package Size : " + strINO.substr(0, strINO.length - 2));
        // }

        // Set status
        if (this.productFilters.status && this.productFilters.status.length > 0) {
          let strINO = '';
          this.productFilters.status.forEach(x => {
            if (x === 'REJECTED') { strINO = strINO + x + ', reject, '; }
            else {
              strINO = strINO + x + ', ';
            }
          });
          this.filterValueList.push('Status : ' + strINO.substr(0, strINO.length - 2));
        }
      }
    }
    this.applyFilterData(this.productFilters);
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.filterInvoicedProductitems = [];
    this.filteredDataCount = 0;

    this.productAllDataSource.filter = filterValue;
    this.filterInvoicedProductitems.forEach(item => {
      if (item.isSelected) {
        this.checkBoxCount = this.checkBoxCount + 1;
      }
    });
  }

  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
    this.isAllProductChecked = false;
  }

  public clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
    }
  }

  // To remove clear search filter
  public removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item Number':
        this.productFilters.invoicedProductList = [];
        break;
      case 'Lot Number':
        this.productFilters.lotNumberList = [];
        break;
      case 'Product Name':
        this.productFilters.productName = '';
        break;
      case 'Package Size':
        this.productFilters.packageSize = '';
        break;
      case 'Vendor Name':
        this.productFilters.vendorName = '';
        break;
      case 'Product Line':
        this.productFilters.productLine = '';
        break;
      case 'Status':
        this.productFilters.status = [];
        break;
      default:
        break;
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Edit/Approval screen enable/disbale buttons
  editButtonStatus() {
    this.disablecheckbox = false;
    this.disableScaleCheckbox = false;
    this.cppReturnsService.setEditModeStatus(true);
    this.isAddProductEnable = true;
    this.enableCreate = false;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.cppReturnsService.getEditRequestDetail(this.returnRequestCppId).subscribe((result: any) => {
      this.cppReturnsService.setEditModeStatus(true);
      this.isEditMode = true;
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.cppReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      if (result.returnRequestStatus === 'DRAFT') {
        this.isSaveOrderDraftEnable = true;
      } else {
        this.isSaveOrderDraftEnable = false;
      }
      this.enableCreate = false;
      this.editApprovalList = result;
      this.disablecheckbox = false;
      this.disableScaleCheckbox = false;
      if (result.cppReturnsProductList && result.cppReturnsProductList.length > 0) {
        result.cppReturnsProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if (this.isReturnTypeForInnoculant) {
            if (x.isIPConfigured && x.returnQuantity > x.eligibleUnit) { x.isShowInoculantWarning = true }
            else { x.isShowInoculantWarning = false }
            if (x.approverNotes != undefined && x.approverNotes != "" && x.approverNotes != null) {
              this.displayedColumns =
                ['checkbox', 'product', 'itemNumber', 'eligibleUnits', 'dumpedUnits', 'uom', 'packageSize', 'notes', 'approverNotes'];
            }
            if (this.isReturnTypeForInnoculant && x.approvedBy && x.isShowInoculantWarning) {
              x.isReturnToDraft = true;
            }
            else {
              x.isReturnToDraft = false;
            }
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      if (this.shipToAccountItems) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
          this.soldToFacility = [accountItem[0].soldToAccount];
          this.soldToAccount = accountItem[0].soldToAccount.accountNumber;
          this.fetchDeliverToFacilityList(accountItem[0].accountNumber, accountItem[0].parentNumber);
        }
      }

      this.cppReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.dsmId = result.dsmId;
      this.isParent = result.isParent;
      this.getFilterMasterList();
      this.cppReturnsService.setProductList(result.cppReturnsProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.cppReturnsProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.cppReturnsProductList));
      this.selectedCount = result.cppReturnsProductList.length;
      this.checkBoxCount = 0;
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      if (this.isEditMode && this.requestStatus != 'DRAFT') {
        this.readOnlyAccess = true;
        this.displayedColumns = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
      }

      this.enableFiltersAndButtonAsPermission();
      this.enablePlaceOrderAndSaveOrderDraft();
      this.cppReturnsService.setSelectedAccountNo(result.shipToAccountId);

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.selectedFreightInstructionOptions = this.freightInstruction.filter(x => result.pickupInfo.freightInstructions.indexOf(x.id) > -1);
      this.palletCount = (result.pickupInfo.palletCount ? result.pickupInfo.palletCount.toString() : '0');
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliverToAnotherLocation = this.deliveryAccount ? true : false;
      this.desiredPickupDate = result.pickupInfo.requestDate;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;

      // Set the desired pickup date based on shipto or pickup account SDM setup
      this.selectedWeekdays = result.accountSDM.isSDM ? result.accountSDM.daysData : [];
      this.defaultDelDate = new Date(result.accountSDM.defaultDelDate);
      this.desiredPickupDate = new Date(result.accountSDM.desiredDelDate);
      this.minDate = this.isinoculentdate ? new Date(result.accountSDM.desiredDelDate) : new Date();
      if (result.accountSDM.isSDM) {
        this.isAcctSDM = true;
      }
      else {
        this.isAcctSDM = false;
      }

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  validateApprovedItems(item: any) {
    const seedPerbag = 140000;
    const cbotPricePerBushel = item.cbotPricePerBushel;
    const poundPerBushel = 60;
    let adjustmentPrice = 0;
    if (parseFloat(item.seedsPerPound) > 0) {
      adjustmentPrice = (seedPerbag / parseFloat(item.seedsPerPound)) * (parseFloat(cbotPricePerBushel) / poundPerBushel);
    }
    // seedPerPoundExist
    if (!item.seedsPerPound) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'seedPerPoundExist');
      item.lineErrors.errors.push({
        id: 'seedPerPoundExist', error: 'Seeds per pound cannot be found to calculate the price adjustment.'
      });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'seedPerPoundExist');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // cbotPriceExist
    if (+item.cbotPricePerBushel <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cbotPriceExist');
      item.lineErrors.errors.push({ id: 'cbotPriceExist', error: 'CBOT price does not exist for item' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cbotPriceExist');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // adjustmentPrice
    if (+adjustmentPrice < 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'adjustmentPrice');
      item.lineErrors.errors.push({ id: 'adjustmentPrice', error: 'The calculated credit price is less than 0' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'adjustmentPrice');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // returnQuantity
    if (!item.isManualLine && parseInt(item.returnQuantity) > parseInt(item.eligibleUnit)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      item.lineErrors.errors.push({ id: 'returnQuantity', error: 'Dumped units cannot exceed the Eligible Units' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // manualLine
    if (item.isManualLine) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'manualLine');
      item.lineErrors.errors.push({ id: 'manualLine', error: 'There is no record of purchase for this item and lot number.' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'manualLine');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    this.originalProductItemsDataSource.find(data => data.itemId === item.itemId && data.lotNumber == item.lotNumber).lineError = item.lineError;
    this.originalProductItemsDataSource.find(data => data.itemId === item.itemId && data.lotNumber == item.lotNumber).isManualLine = item.isManualLine;
    return item;
  }

  getUserList(accountNumber) {
    this.loaderService.setLoaderStatus(true);
    const self = this;

    this.subscription.add(this.cppReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        this.requestOnBehalfList = result;
        if (this.currentRequestedUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
          this.onBehalfUser = requestItem[0].userId;
          this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
          this.requestedByUser = requestItem[0].userId;
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  enableFiltersAndButtonAsPermission() {
    if (!this.isEditMode) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Create Return Request';
    }
    else if (this.isEditMode && this.requestStatus == 'DRAFT' && this.createRequestAccess) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Edit Return Request [' + this.returnRequestNumber + ']';
    }
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enablePlaceOrderAndSaveOrderDraft() {
    if (this.productAllDataSource && this.productAllDataSource.data.length > 0 && this.shipToAccount && (!this.isNotValid) && this.checkAnyValidLineItem()) {
      this.isSaveOrderDraftEnable = true;
    } else {
      this.isSaveOrderDraftEnable = false;
    }
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    // get Item Number List
    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    this.subscription.add(this.cppReturnsService.getAccountUser(0).subscribe((result: any) => {
      this.requestOnBehalfList = result;
      if (!this.isEditMode) {
        this.onBehalfUser = this.requestOnBehalfList[0].userId;
        this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : this.requestOnBehalfList[0].userEmail;
        this.requestedByUser = this.requestOnBehalfList[0].userId;
        this.currentRequestedUser = this.requestOnBehalfList[0].userId;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // for adding product
  addProduct() {
    this.cppReturnAddProductSliderModelService.activeSlider('AddCppReturnProductSlider');
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllProductChecked = isChecked;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.editToolKit = true;
        if (this.cppReturnsService.getEditModeStatus()) {
          this.showTabs = true;
          this.isSearchClicked = false;
        }

        this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemId == 0).length > 0 ? true : false;
      }
      else {
        this.editToolKit = false;
      }
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;

      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.productAllDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      const selected = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (selected && selected.length == 0) {
          this.showTabs = false;
        }
        else {
          this.showTabs = true;
        }
      }
    }
    this.editToolKit = false;
    const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
    this.isValidLineStatus = false;
    if (selectedItem.length > 0) {
      this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemCppId == 0).length > 0 ? true : false;
      this.editToolKit = true;
      if (this.isValidLineStatus && this.cppReturnsService.getEditModeStatus()) {
        this.showTabs = true;
        this.isSearchClicked = false;
      } else if (!this.isValidLineStatus && this.cppReturnsService.getEditModeStatus()) {
        this.editToolKit = false;
      }
    }
  }

  getFilterMasterList() {
    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }
  }

  hasEmailAddressChanged() {
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnEmailAddressValue: true });
    }
  }

  setUserEmail(event) {
    if (event) {
      this.accountEmail = event.userEmail;
      this.selectedUserName = event.userName;
      this.requestedByUser = event.userId;
    } else {
      this.accountEmail = null;
      this.requestedByUser = null;
      this.selectedUserName = null;
    }
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasReturnRequestOnBehalfOfChange: true });
    }
  }

  getShipTo(event) {
    if (event) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.cppReturnsService.getDraftReturnRequest(event.accountNumber)
        .subscribe(response => {
          if (response > 0) {
            this.returnRequestCppId = response;
            // display confirm message if existing Draft return request for the selected account and product line
            const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
              disableClose: true,
              width: '480px',
              panelClass: 'drafSeedReturnConfirmModal',
              data: {
                title: 'Confirmation',
                htmlMessage: 'There is an existing Draft return request for the selected account and product line. Do you want to continue with that?',
                labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm'
              }
            });
            this.subscription.add(dialogRef.afterClosed().subscribe(result => {
              // If user selected ok
              if (result == true) {
                this.router.navigate(['/cpp-returns/request-products', this.returnRequestCppId]);
              } else {
                this.setValuesForCreateNewReturn(event);
              }
            }));
          } else {
            this.soldToFacility = [event.soldToAccount];
            this.soldToAccount = event.soldToAccount.accountNumber;
            this.setValuesForCreateNewReturn(event);
          }
          this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false))
      );
    } else {
      this.dsmInfo = '';
      this.dsmId = 0;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.deliveryAccount = null;
      this.deliveryAccountList = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.invoicedProductList = [];
      if (this.currentRequestedUser) {
        const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        this.onBehalfUser = requestItem[0].userId;
        this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
        this.requestedByUser = requestItem[0].userId;
      }
    }

    this.clearAllFilter();
    // reset pickup location checkbox & dropdown if ship to is changed or reset.
    this.deliverToAnotherLocation = false;
    this.deliveryAccount = null;
    this.productSearchFilter = this.searchTypeList[0].value;
    this.disablecheckbox = true;
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.originalProductItemsDataSource = [];
    this.bindDataSource([], true);
    this.checkBoxCount = 0;
    this.selectedCount = 0;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.enableAllCheckBoxes(false);
    this.showScaleTabs = false;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  private setValuesForCreateNewReturn(event) {
    this.loaderService.setLoaderStatus(true);
    this.isExpanded = false;
    this.dsmInfo = '';
    this.isAddProductEnable = true;

    this.soldToFacility = [event.soldToAccount];
    this.soldToAccount = event.soldToAccount.accountNumber;

    this.selectedAccountName = event.accountName;
    this.shipToAccount = event.accountNumber;
    this.cppReturnsService.setSelectedAccountNo(event.accountNumber);
    this.cppReturnsService.setSelectedParentAccountNo(event.parentNumber);
    this.getFilterMasterList();
    this.subscription.add(this.cppReturnsService.getDSMInfo(event.accountNumber, this.cropYear).subscribe((result: any) => {
      this.dsmInfo = result && result.dsmAccountName ? result.dsmAccountName : '';
      this.dsmId = result && result.dsmId ? result.dsmId : 0;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
    this.getUserList(event.accountNumber);
    this.fetchDeliverToFacilityList(event.accountNumber, event.parentNumber);
    this.getDefaultDeliveryDate(event);
  }

  saveDraft(isSubmit: boolean) {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    if (this.validateOrder(isSubmit)) {
      this.isPlaceOrderEnable = false;
      this.isSaveOrderDraftEnable = false;
      const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
      const newLineItems = [];
      productList.filter(x => {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
        x.lineStatus = 'DRAFT';
        x.errorMessage = null;
      });
      const postData = {
        ReturnRequestCppId: this.returnRequestCppId,
        ReturnRequestType: this.isReturnTypeForInnoculant ? 'INOCULANT' : 'PRODUCTS',
        ReturnRequestStatus: 'DRAFT',
        CompanyCode: this.headerCompany,
        ShipToAccountId: this.shipToAccount,
        IsUpdateRequest: this.cppReturnsService.getEditModeStatus(),
        DsmId: this.dsmId,
        BranchPlant: null,
        CPPReturnProductList: productList,
        Email: this.accountEmail,
        RequestedBy: this.requestedByUser,
        PickupInfo: {
          RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null),
          ContactName: (this.contactName ? this.contactName : ''),
          ContactNumber: (this.contactNumber ? this.contactNumber : ''),
          PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
          ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
          FreightInstructions: this.freightInstructionCtrl.selectedOptions.selected.map(x => x.value.id).join(),
          PalletCount: (this.palletCount ? Number(this.palletCount) : null),
          CustPONumber: (this.customerPONumber ? this.customerPONumber : '')
        },
      };
      this.loaderService.setLoaderStatus(true);

      this.subscription.add(this.cppReturnsService.submitReturnRequest(postData).subscribe((result: any) => {
        if (result) {
          if (result.errors.length > 0) {
            this.loaderService.setLoaderStatus(false);
            result.errors.forEach(x => {
              this.toastrService.error(x);
              return false;
            });
          }
          else {
            const errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
            if (errorCount > 0) {
              this.productAllDataSource.data = result.cppReturnProductList;
              this.productAllDataSource.data.forEach(x => {
                const item = newLineItems.filter(y => y.itemId == x.itemId);
                if (item.length > 0) {
                  x.lineStatus = item[0].lineStatus;
                }
                if (x.errorMessage != '' && x.errorMessage != null) {
                  x.lineErrors = { 'itemId': x.itemId, 'errors': [{ 'error': x.errorMessage }] };
                  this.errorMsgs.push(x.lineErrors);
                }
                else {
                  x.lineErrors = { 'itemId': x.itemId, 'errors': [] };
                }
              });
              this.getCommonErrors(this.errorMsgs);
              this.loaderService.setLoaderStatus(false);
            } else {
              let successMsg = "";
              if (this.isReturnTypeForInnoculant) {
                successMsg = "Inoculant return request saved successfully."
              }
              else {
                successMsg = "CPP return request saved successfully."
              }
              this.toastrService.success(successMsg);

              if (isSubmit) {
                this.router.navigate([`/cpp-returns/products-review/${result.returnRequestCppId}`]);
              } else {
                if (this.isReturnTypeForInnoculant) {
                  this.router.navigate([`/cpp-returns/dashboard-products/Inoculant`]);
                }
                else {
                  this.router.navigate([`/cpp-returns/dashboard-products`]);
                }
              }

              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              this.loaderService.setLoaderStatus(false);
            }
          }
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.isPlaceOrderEnable = true;
        this.isSaveOrderDraftEnable = true;
        this.toastrService.error('Return Request not saved in the system.');
      }));
    }
  }

  desiredPickupDateValid(pickupDate: AbstractControl) {
    if (pickupDate.valid && pickupDate['model'] >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  ValidateSelectedDesiredPickupDate(event) {
    if (event.value && event.value >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  countShouldBeValid(count: AbstractControl) {
    if (count.valid) {
      this.isPalletValid = true;
    } else {
      this.isPalletValid = false;
    }
  }
  phoneShouldBeValid(phone: AbstractControl) {
    if (phone.valid) {
      this.isContactValid = true;
    } else {
      this.isContactValid = false;
    }
  }
  nameShouldBeValid(name: AbstractControl) {
    if (name.valid) {
      this.isNameValid = true;
    } else {
      this.isNameValid = false;
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // update grid value from toolKit on update
  setAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        this.tabNode = '';
        if (value) {
          this.isAllProductChecked = false;
          this.showTabs = false;
          this.editToolKit = false;
          const productAllList = this.productAllDataSource.filteredData.filter(x => x.isSelected === true);

          if (productAllList.length == this.productAllDataSource.data.length) {
            this.errorMsgs = [];
            this.productAllDataSource = new MatTableDataSource([]);
            this.bindDataSource([], true);
            this.originalProductItemsDataSource = [];
          } else {
            productAllList.forEach(items => {
              let index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
              index = this.productAllDataSource.data.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.productAllDataSource.data.splice(index, 1);
              }

              index = this.originalProductItemsDataSource.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.originalProductItemsDataSource.splice(index, 1);
              }
            });
          }
          this.applyFilterData(this.productFilters);
          this.checkBoxCount = 0;
          this.selectedCount = this.productAllDataSource.data.length;
          if (this.selectedCount == 0) {
            this.disablecheckbox = true;
          }
        }

        this.enablePlaceOrderAndSaveOrderDraft();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        break;
      default:
        break;
    }
  }

  SetDesiredPickupDate() {
    this.desiredPickupDate = new Date(this.desiredDelDate);
  }

  getDefaultDeliveryDate(event) {
    const accountNumber = this.deliveryAccount ? this.deliveryAccount : this.shipToAccount;
    const inoculantReturnType = this.isReturnTypeForInnoculant;
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.cppReturnsService.getAccountSDMData(accountNumber, inoculantReturnType).subscribe((result) => {
      if (!this.deliveryAccount) {
        this.selectedWeekdays = result.isSDM ? result.daysData : [];
        this.selectedShipToWeekdays = result.isSDM ? result.daysData : [];
        this.defaultDelDate = new Date(result.defaultDelDate);
        this.defaultShipToDelDate = new Date(result.defaultDelDate);
        this.desiredPickupDate = new Date(result.desiredDelDate);
        this.desiredShipToPickupDate = new Date(result.desiredDelDate);
        if (this.isReturnTypeForInnoculant) {
          this.minDate = this.isinoculentdate ? new Date(result.desiredDelDate) : new Date();
        }
        if (result.isSDM) {
          this.isAcctSDM = true;
        }
        else {
          this.isAcctSDM = false;
        }
      }
      else {
        if (result.isSDM) {
          this.selectedWeekdays = result.isSDM ? result.daysData : [];
          this.defaultDelDate = new Date(result.defaultDelDate);
          this.desiredPickupDate = new Date(result.desiredDelDate);
          this.isAcctSDM = true;
          if (this.isReturnTypeForInnoculant) {
            this.minDate = this.isinoculentdate ? new Date(result.desiredDelDate) : new Date();
          }
        }
        else {
          // Keep the ShipTo Account based SDM/Default date
          this.selectedWeekdays = this.selectedShipToWeekdays;
          this.defaultDelDate = new Date(this.defaultShipToDelDate);
          this.desiredPickupDate = new Date(this.desiredShipToPickupDate);
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  validateOrder(isSubmit: boolean) {
    let isValidated = true;

    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      isValidated = true;
      this.productAllDataSource.data.forEach(x => {
        if (x.lineStatus !== 'REJECTED') {
          x = this.validateQty(x);
          if (x.lineErrors.errors.length > 0) {
            isValidated = false;
          }
        } else {
          x.lineErrors.errors = [];
        }
      });
    }

    if (this.isPickupDateValid) {
      if (!this.desiredPickupDate || this.desiredPickupDate == '') {
        this.SetDesiredPickupDate();
      }
      else if (this.desiredPickupDate < new Date(new Date().setHours(0, 0, 0, 0))) {
        isValidated = false;
        this.toastrService.error('Desired pickup date should be today or greater.');
      }
    } else {
      isValidated = false;
      if (!isSubmit) {
        this.toastrService.error('Requested Desired pickup date is invalid.');
      }
    }

    if (isSubmit) {
      if (!this.desiredPickupDate) {
        isValidated = false;
        this.toastrService.error('Please enter desired pickup date.');
      }
      // else if (this.desiredPickupDate < new Date(new Date().setHours(0, 0, 0, 0))) {
      //  isValidated = false;
      //  this.toastrService.error('Desired pickup date should be today or greater.');
      // }
      else if (!this.contactName) {
        isValidated = false;
        this.toastrService.error('Please enter a contact name.');
      } else if (!this.contactNumber) {
        isValidated = false;
        this.toastrService.error('Please enter a contact number.');
      } else if (!this.palletCount || this.palletCount === '') {
        isValidated = false;
        this.toastrService.error(isSubmit ? 'Please enter the number of pallets being returned.' : 'Please enter a pallet count.');
      }
    }
    return isValidated;
  }

  checkAnyValidLineItem() {
    const errorCount = this.productAllDataSource.data.filter(x => x.lineErrors.errors.length > 0).length;
    return (errorCount > 0 ? false : true);
  }

  // Line item validation
  validateLineItem(item: any) {
    // Stocking Type - Scenario Edit/Approval
    if (item.stockingType == 'O') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'stockingType');
      item.lineErrors.errors.push({ id: 'stockingType', error: 'NonReturnable - Obsolete Product' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'stockingType');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Item Flash msg - Scenario Edit/Approval
    if (item.itemFlashMsgDesc && item.itemFlashMsgDesc.toUpperCase().trim() === 'NONRETURNABLE') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'itemFlashMsgDesc');
      item.lineErrors.errors.push({ id: 'itemFlashMsgDesc', error: 'This product is non-returnable' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'itemFlashMsgDesc');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    const productCategory = ['3PA', '3PC', '3PF', '3PN', '3PV'];
    // Product Category - Scenario Edit/Approval
    if (item.productCategory in productCategory) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productCategory');
      item.lineErrors.errors.push({ id: 'productCategory', error: 'Product category not eligible for return' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productCategory');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Quantity
    if (!item.isManualLine && parseInt(item.returnQuantity) > parseInt(item.eligibleUnit)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      item.lineErrors.errors.push({ id: 'returnQuantity', error: 'Dumped units cannot exceed the Eligible Units' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Period End Date
    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (!item.isManualLine && Date.parse(currentDate) > Date.parse((new Date(item.returnPeriodEnd)).toLocaleDateString('en-US').replace(/\u200E/g, '')) && this.roleType != 'INTERNAL') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnPeriodEnd');
      item.lineErrors.errors.push({ id: 'returnPeriodEnd', error: 'Please contact your DSM or Customer Service regarding your Return Request.' });
    }

    // Invoice Date between invoice start date and invoice end date
    const invoiceDate = new Date(item.originalInvoiceDate).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (!item.isManualLine && Date.parse(invoiceDate) < Date.parse((new Date(item.originalInvoiceStartDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')) ||
      (Date.parse(invoiceDate) > Date.parse((new Date(item.originalInvoiceEndDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')))) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'originalInvoiceDate');
      item.lineErrors.errors.push({ id: 'originalInvoiceDate', error: 'Invoice date not valid.Please contact your DSM or Customer Service regarding your Return Request.' });
    }
    return item;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.originalProductItemsDataSource.length > 0 && this.productAllDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.filter(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productAllDataSource.data.findIndex(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productAllDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productAllDataSource.data = this.productAllDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId && element.lotNumber === oldLineValue.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId, oldLineValue.lotNumber);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productAllDataSource.data = JSON.parse(JSON.stringify(this.originalProductItemsDataSource));
        this.productAllDataSource.data.forEach(x => {
          x.eligibleUnit = x.isManualLine ? 0 : ((x.invoiceUnits && x.totalReturnUnits) ? (x.invoiceUnits - x.totalReturnUnits) : x.eligibleUnit);
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.isPlaceOrderEnable = true;
      this.isSaveOrderDraftEnable = true;
    }
    this.enablePlaceOrderAndSaveOrderDraft();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.isAllProductChecked = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number, lotNumber: string) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString() + '_' + lotNumber);
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  unitChange(action: string, productItem: any) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }
    if (action == 'decrease') {
      let decValue;
      if (productItem.uom !== productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0)) {
        decValue = +productItem.returnQuantity - +productItem.conversionFactor;
        if (decValue > 0) {
          const valueBeforeDec = productItem.returnQuantity;
          productItem.returnQuantity = Math.floor(productItem.returnQuantity / +productItem.conversionFactor) * +productItem.conversionFactor;
          if (valueBeforeDec == productItem.returnQuantity) {
            productItem.returnQuantity = (+productItem.returnQuantity > +productItem.conversionFactor ? +productItem.returnQuantity - +productItem.conversionFactor : 0);
          }
        }
      } else {
        decValue = + parseInt(productItem.returnQuantity) - 1;
      }
      if (decValue > 0) {
        productItem.returnQuantity = decValue;
      }
      else {
        productItem.returnQuantity = 0;
        if (decValue < 0) {
          this.toastrService.error('Requested units cannot be negative.');
        }
      }
      productItem = this.validateQty(productItem);
    }
    else {
      if (productItem.uom !== productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0)) {
        const valueBeforeInc = productItem.returnQuantity;
        productItem.returnQuantity = Math.ceil(productItem.returnQuantity / +productItem.conversionFactor) * +productItem.conversionFactor;
        if (valueBeforeInc == productItem.returnQuantity) {
          productItem.returnQuantity = (+productItem.returnQuantity + +productItem.conversionFactor);
        }
      } else {
        productItem.returnQuantity = +productItem.returnQuantity + 1;
      }
      productItem = this.validateQty(productItem);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity });
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  validateQty(productItem) {
    let maxQuantityCanBeOrdered = productItem.actualInvoiceUnits - (productItem.totalReturnUnits + productItem.creditIssued);
    if (productItem.returnQuantity === '' || productItem.returnQuantity === 0 || Number(productItem.returnQuantity) === 0) {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Please enter a request quantity' });
    } else if (Number(productItem.returnQuantity) < 0) {
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Please enter a positive number request quantity' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (productItem.uom != productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0) && productItem.returnQuantity < productItem.eligibleUnit && (productItem.returnQuantity % productItem.conversionFactor) !== 0) {
      productItem.lineErrors.errors.push({ id: 'returnQuantity', error: 'Please re-enter your Return Units in multiples of ' + (productItem.conversionFactor) });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    if (this.isReturnTypeForInnoculant) {
      //if (productItem.returnQuantity > productItem.eligibleUnit && productItem.ipPercentage == 100 && productItem.isIPConfigured == false) {
      //  productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      //  productItem.lineErrors.errors.push({ id: 'returnQuantity', error: 'Requested units cannot exceed the Eligible Return Units' });
      //}
      //else
      if (productItem.isIPConfigured == false) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
        productItem.lineErrors.errors.push({ id: 'returnQuantity', error: this.ipNotConfiguredErrorMessage });
      }
      else if (productItem.uom != productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0) && productItem.returnQuantity < productItem.eligibleUnit && (productItem.returnQuantity % productItem.conversionFactor) !== 0) {
        productItem.lineErrors.errors.push({ id: 'returnQuantity', error: 'Please re-enter your Return Units in multiples of ' + (productItem.conversionFactor) });
      }
      else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
        })
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if ((productItem.returnQuantity > productItem.eligibleUnit && productItem.returnQuantity <= maxQuantityCanBeOrdered) && productItem.isIPConfigured) {
      productItem.isShowInoculantWarning = true;
    }
    else if (productItem.returnQuantity > maxQuantityCanBeOrdered && productItem.isIPConfigured) {
      productItem.lineErrors.errors.push({ id: 'returnQuantity', error: "Return Quantity Can not Exceed Invoiced Quantity." });
      productItem.isShowInoculantWarning = false;
    }
    else {
      productItem.isShowInoculantWarning = false;
    }

    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity });
    productItem = this.validateQty(productItem);
    this.isAddProductEnable = true;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  hasNotesChanged(textInput: string) {
    if (textInput && textInput.length > 0) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnValue: true });
    }
    if (textInput && textInput.length >= 250) {
      this.toastrService.error('The maximum number of characters has been been reached.');
    }
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.productAllDataSource.data.length;
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  getAccountList() {
    this.subscription.add(this.cppReturnsService.getAccountList().subscribe((result: any[]) => {
      this.shipToAccountItems = result;
      this.shipToDataLoading = false;
      if (this.shipToAccount) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
          this.soldToFacility = [accountItem[0].soldToAccount];
          this.soldToAccount = accountItem[0].soldToAccount.accountNumber;
          this.fetchDeliverToFacilityList(accountItem[0].accountNumber, accountItem[0].parentNumber);
        }
      }
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
    })));
  }

  getFreightList() {
    if (this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST)) {
      this.freightInstruction = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST));
    }
  }

  // On page destroy
  ngOnDestroy() {
    this.cppReturnsService.setCppReturnRequestId(0);

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private fetchDeliverToFacilityList(accountNumber: number, parentNumber: number) {
    this.subscription.add(this.cppReturnsService.getDeliverToFacilityList(accountNumber, parentNumber)
      .subscribe((result: any[]) => {
        this.deliveryAccountList = result;
      }, error => this.loaderService.setLoaderStatus(false))
    );
  }

  private isValidPickInfo(): boolean {
    return this.desiredPickupDate && this.isPickupDateValid && this.isNameValid && this.isContactValid && this.isPalletValid;
  }

  public isDisableSubmitRequestBtn(): boolean {
    return !this.isSaveOrderDraftEnable;
  }

  public isDisableSaveDraftBtn(): boolean {
    return !this.isSaveOrderDraftEnable;
  }

  UpdateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.deliveryAccount = null;
      this.getDefaultDeliveryDate(event);
    }
  }

  // highlighting weekdays
  getIsHoliday(date: NgbDate) {
    const todayDate = new Date();
    if (this.isAcctSDM
      && new Date(date.year, date.month - 1, date.day) >= this.defaultDelDate
      && new Date(date.year, date.month - 1, date.day) >= todayDate) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    } else {
      return false;
    }
  }

  dateClass() {
    return (dDate: Date): MatCalendarCellCssClasses => {
      const todayDate = new Date();
      const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());

      if (this.desiredPickupDate == null) {
        this.desiredPickupDate = new Date(this.defaultDelDate);
      }

      if (this.calendar.getWeekday(ngDate) < 7
        && dDate >= this.desiredPickupDate) {
        if (this.selectedWeekdays.includes(this.calendar.getWeekday(ngDate))) {
          return 'holiday';
        }
        else {
          return 'mat-weekdays';
        }
      }
      else if (dDate >= todayDate
        && this.calendar.getWeekday(ngDate) < 7) {
        return 'mat-weekdays';
      }
      else {
        return undefined;
      }
    };
  }

  onOpen() {
    if (this.isAcctSDM) {
      setTimeout(() => { this.appendFooter(); }, 0);
    }
  }

  appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }
}
